import { Component, Input } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { Agent, AgentServicev2 } from '../agent-builder-services/agent.service';
import { KnowledgeBase, KnowledgeBaseService } from '../agent-builder-services/knowledge-base.service';
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { HttpEventType } from '@angular/common/http';
import { UploadServices } from 'src/app/services/upload.services';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'agent-builder-kb-upload',
  templateUrl: './agent-builder-kb-upload.component.html',
  styleUrls: ['./agent-builder-kb-upload.component.scss'],
  standalone: false
})
export class AgentBuilderKbUploadComponent {

  @Input() agent:Agent;
  fileList: File[] = [];
  uploading = false;
  data:any[] = [];
  fileListZorro: NzUploadFile[] = [];
  loadingKB = false;

  constructor(
    private ks: KnowledgeBaseService,
    private message: NzMessageService,
    private ls:LanguageServices,
    private updLoad:UploadServices,
    private modal:NzModalService
  ) {}


    onChangeFileList(event: NzUploadChangeParam) {
        this.fileListZorro = event.fileList;

        const file = event.file;

    }


    beforeUpload = (file: NzUploadFile): boolean => {

        const nome = file.name.toLowerCase();

        const jaExiste = this.fileListZorro.some(f => f.name.toLowerCase() === nome);

        if (jaExiste) {
            throw Error(this.ls.instant('agentBuilder.kb_already_file_exists',{filename:file.name}));
        }


        return true; // permite o upload multipart automático
    };

    ngOnInit(): void {
        this.loadData();
    }

    getTotalChunks(data:any[]){
        const total = data.reduce((acc, item) => acc + item.chunks, 0);
        return total;
    }


    loadData(): void {

        if ( this.agent._id == null ){
            return;
        }
        
        this.loadingKB = true;
        this.ks.getKnowledgeBaseFiles(this.agent).subscribe({
        next: (data) => {
            this.data = data['SQL'] || [];
            this.loadingKB = false;
        },
        error: (error) => {
            this.message.error (this.ls.instant('agentBuilder.kb_fail_load_bk')+':'+GlobalErrorHandler.getMessage(error));
            this.loadingKB = false;
        }
        });
    }

    formatFileSize(bytes?: number): string {
        if (!bytes) return '-';
    
        const sizes = ['B', 'KB', 'MB', 'GB'];
        if (bytes === 0) return '0 B';
            const i = Math.floor(Math.log(bytes) / Math.log(1024));
        
            return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    }


    removeKb(item){

        this.modal.confirm({
            nzTitle: 'Confirmar',
            nzContent: 'Desaja realmente excluir essa base de conhecimento?',
            nzOkText: 'Sim',
            nzCancelText: 'Não',
            nzOnOk: () => {
                this.loadingKB = true;
                this.ks.deleteKnowledgeBase(item, this.agent).subscribe({
                        next:(data)=>{
                            this.message.success(this.ls.instant('agentBuilder.kb_success_removed'));
                            this.loadData();
                        },
                        error(err) {
                            this.loadingKB = false;
                            this.message.error (this.ls.instant('agentBuilder.kb_error_removed')+':'+GlobalErrorHandler.getMessage(err));
                        },
                })
            }
        });
    }

    customUpload = (item: NzUploadXHRArgs) => {

        if (!this.agent._id) {
            this.message.error(this.ls.instant('agentBuilder.kb_save_agent_before'));
        return;
        }

        const formData = new FormData();
        formData.append('file', item.file as any);
        this.loadingKB = true;
        const subProgress = this.updLoad.progress.subscribe(value => {
            const percent = Number(value) || 0;

            const progressEvent: any = {
                type: HttpEventType.UploadProgress,
                loaded: percent,
                total: 100,
                percent
            };

            try {
                item.onProgress?.(progressEvent, item.file!);
            } catch {
                
            }
        });

        this.updLoad.upLoadFileFlex(formData, "AiServices/injest/uploadfile", true).subscribe({
            next:async(event) => {  
                
                if (event instanceof Object && !Array.isArray(event) && event.hasOwnProperty('path')) {
                    let ob = event;
                    let kb:KnowledgeBase = {
                        filePath: ob.path,
                        fileName: ob.fileName,
                        fileSize: ob.fileSize,
                        mimeType: ob.mimeType
                    }
                    
                    await this.ks.updateKnowledgeBase(this.agent, kb).then(
                        (data) => {
                            this.message.success(this.ls.instant('agentBuilder.kb_success_uploaded'));
                            this.loadingKB = false;
                            this.loadData();
                            const percent = 100;
                            item.onSuccess?.({percent:percent}, item.file!, null as any);
                            subProgress.unsubscribe();
                        },
                        (error) => {
                            let message = GlobalErrorHandler.getMessage(error) || this.ls.instant('agentBuilder.kb_fail_uploaded');
                            this.message.error(message);
                            this.loadingKB = false;
                            const msg = message;
                            item.file!.status = 'error';
                            item.file!.error = msg;
                            item.file!.response = error.error;
                            item.onError!(msg, item.file!);


                            
                        }
                    );             
                    
                }
            },
            error: (error) => {
                item.onError?.(error, item.file!);
                this.loadingKB = false;
                subProgress.unsubscribe();
            },
            complete: () => {
                item.onSuccess?.({}, item.file!,null);
                subProgress.unsubscribe();
            }
        });
    };


    


  
}